export enum ReservationStatus {
  ACTIVE = 'ACTIVE',
  WAITING = 'WAITING',
  COMPLETED = 'COMPLETED',
}
